import { ThemeProvider } from "styled-components"
import React from "react"

/*generator do kolorów dla icon hover*/
// https://codepen.io/sosuke/pen/Pjoqqp

const theme = {
    colors: {
        mainColor: 'black !important;',
        white: 'white !important;'
    }
}

const Theme = ({children}) => (
    <ThemeProvider theme={theme}>{children}</ThemeProvider>
);

export default Theme;